import { Controller } from "@hotwired/stimulus"

// Handles copy-to-clipboard for code blocks in documentation
// Registered as "docs--code-copy"
export default class extends Controller {
  async copy(event) {
    const button = event.currentTarget
    const codeBlock = this.element.querySelector("code")
    if (!codeBlock) return

    const text = codeBlock.textContent || ""

    try {
      await navigator.clipboard.writeText(text)
      const label = button.querySelector(".docs-copy-label")
      if (label) {
        const original = label.textContent
        label.textContent = "Copied!"
        setTimeout(() => {
          label.textContent = original
        }, 2000)
      }
    } catch {
      // Fallback for older browsers
      const textarea = document.createElement("textarea")
      textarea.value = text
      textarea.style.position = "fixed"
      textarea.style.opacity = "0"
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand("copy")
      document.body.removeChild(textarea)
    }
  }
}
